import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'
import { buildAbilitiesForUser } from '@src/utility/subUserAccess'

let existingAbility = []

try {
  const userdata = JSON.parse(localStorage.getItem('auth'))
  existingAbility = buildAbilitiesForUser(userdata)
} catch {
  existingAbility = [{ action: 'manage', subject: 'all' }]
}

export default new Ability(existingAbility || initialAbility)
